export default "<dc-reportcard reportcard=\"vm.reportcard\"></dc-reportcard>";